import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-58061858")

_pushScopeId("data-v-58061858")
const _hoisted_1 = { class: "ExpressAdditionalData" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "ExpressAdditionalData__title" }, "Дополнительная информация", -1)
const _hoisted_3 = { class: "ExpressAdditionalData__body" }
const _hoisted_4 = { class: "body__verification" }
const _hoisted_5 = { class: "ExpressAdditionalData__actions" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Подтвердить")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_input = _resolveComponent("s-input")!
  const _component_s_checkbox = _resolveComponent("s-checkbox")!
  const _component_s_text_area = _resolveComponent("s-text-area")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_s_input, {
        disabled: _ctx.disabled,
        placeholder: "Наложенный платёж",
        value: _ctx.state.amount_to_accept_payment,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.amount_to_accept_payment = $event)),
        maska: {
                    mask: [
                        '# ₸',
                        '## ₸',
                        '### ₸',
                        '# ### ₸',
                        '## ### ₸',
                        '### ### ₸',
                        '# ### ### ₸',
                        '## ### ### ₸',
                        '### ### ### ₸',
                    ],
                }
      }, null, 8, ["disabled", "value"]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_s_checkbox, {
          disabled: _ctx.disabled,
          theme: "green",
          label: "Верификация SPARK",
          value: _ctx.state.is_spark_verification,
          "onUpdate:value": [
            _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.is_spark_verification = $event)),
            _cache[3] || (_cache[3] = ($event: any) => (_ctx.onCheckboxChange('spark')))
          ]
        }, null, 8, ["disabled", "value"]),
        _createVNode(_component_s_checkbox, {
          disabled: _ctx.disabled,
          theme: "blue",
          label: "Верификация Kaspi (Для доставок покупателям из Kaspi Магазина)",
          value: _ctx.state.is_kaspi_verification,
          "onUpdate:value": [
            _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.is_kaspi_verification = $event)),
            _cache[5] || (_cache[5] = ($event: any) => (_ctx.onCheckboxChange('kaspi')))
          ]
        }, null, 8, ["disabled", "value"])
      ]),
      (_ctx.state.is_kaspi_verification)
        ? (_openBlock(), _createBlock(_component_s_input, {
            key: 0,
            placeholder: "Номер заказа Kaspi",
            disabled: _ctx.disabled,
            "is-invalid": _ctx.v$.verification_invoice_number.$error,
            value: _ctx.state.verification_invoice_number,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.verification_invoice_number = $event))
          }, null, 8, ["disabled", "is-invalid", "value"]))
        : _createCommentVNode("", true),
      _createVNode(_component_s_input, {
        disabled: _ctx.disabled,
        placeholder: "Номер накладной заказчика",
        value: _ctx.state.verification_invoice_number,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.verification_invoice_number = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_s_text_area, {
        disabled: _ctx.disabled,
        placeholder: "Кратко опишите детали заказа",
        value: _ctx.state.extra_info,
        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.extra_info = $event))
      }, null, 8, ["disabled", "value"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_s_button, {
        class: "blue",
        disabled: _ctx.disabled,
        onClick: _ctx.emitSubmit
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
})